import React from "react";
import { Link } from "react-router-dom";

import { Image } from "@fluentui/react-northstar";
import { iconAssets } from "../assets/theme/theme";

function PlatformNavigation({ id ,selectedTab,clientName}) {
  return (
    <div className='row  p-0 w-100'>
        <div className='col-auto px-2'>
          <Link to="/" ><button className={selectedTab === "Dashboard" ? "breadcrumbs-button" : "breadcrumbs-button-outline"}>Dashboard</button> </Link>
        </div>
        <div className='col-auto px-1'>
          <Image src={iconAssets.slash} alt="" className="slash-icon" />
        </div>
        <div className='col-auto px-2'>
          <Link to={`/view-client/${id}`}><button className={selectedTab === "Client Dashboard" ? "breadcrumbs-button" : "breadcrumbs-button-outline"}>{clientName}</button></Link>
        </div>
        <div className='col-auto px-1'>
          <Image src={iconAssets.slash} alt="" className="slash-icon" />
        </div>
        <div className='col-auto px-1'>
          <button className='breadcrumbs-button-outline-notify'>Send Notification</button>
        </div>
        <div className='col-auto px-1'>
          <Image src={iconAssets.slash} alt="" className="slash-icon" />
        </div>
        <div className='col-auto px-2'>
          <Link to={`/view-client/${id}/users`}><button className={selectedTab === "Manage Users" ? "breadcrumbs-button" : "breadcrumbs-button-outline"}>Manage Users</button></Link>
        </div>
        <div className='col-auto px-1'>
          <Image src={iconAssets.slash} alt="" className="slash-icon" />
        </div>
        <div className='col-auto px-2'>
          <Link to={`/view-client/${id}/skills`}><button className={selectedTab === "Manage Skills" ? "breadcrumbs-button" : "breadcrumbs-button-outline"}>Manage Skills</button></Link>
        </div>
      </div>
  );
}

export default PlatformNavigation;
